import axios from "axios";

const api = axios.create({
  baseURL: "https://daily-diary-gray.vercel.app",
});

export default api;
